import { render, staticRenderFns } from "./chatFoot.vue?vue&type=template&id=27a0ef52&scoped=true&"
import script from "./chatFoot.vue?vue&type=script&lang=js&"
export * from "./chatFoot.vue?vue&type=script&lang=js&"
import style0 from "./chatFoot.vue?vue&type=style&index=0&id=27a0ef52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0ef52",
  null
  
)

export default component.exports